export class AppConstants {
    //4 hours 10mins
    public static Default_Session_Length = "04:10";
    public static SweetAlert_Error_Title = "Error";
    public static Max_Session_Per_Week = 14;
    public static Max_Hours_Per_Week = 60;
    public static Max_Minutes_Per_Week = 59;

    //Diary
    public static showAllEmployers = "1";
    public static showSelectedEmployer = "2";
    public static leaveSubCategoryName = "Leave";
    public static dutyDaySubCategoryName = "Duty/on-call period";
    public static breakSubCategoryName = "Break";
    public static dayView = "day";
    public static weekView = "week";
    public static dccActivtyShortName = "DCC";
    public static iccActivtyShortName = "ICC";
    public static workDayStart = "08:00";
    public static workDayEnd = "19:00";
    public static monthView = "month";
    public static otherActivityName = "Other (add your own activity)";
    public static otherActivitySubCatgoryId = -111;

    //To show and hide the text if duty day activity selected
    public static dutyOnCallSubCategoryIdForactivitydropdown = 26;

    //JobCategoryIds
    public static DCC_Category_Id = 1;
    public static ICC_Category_Id = 2;
    public static Non_Clinical_Work_Category_Id = 3;
    public static Training_And_Supervision_Category_Id = 4;
    public static CPD_Category_Id = 5;
    public static Break_Category_Id = 6;
    public static Leave_Category_Id = 7;
    public static Duty_On_Call_Period_Category_Id = 8;
    public static Employer_Contract_Hours_Category_Id = -888;
    public static Total_Worked_Category_Id = -999;
    public static Academic_Category_Id = 100;

    //Report
    public static inCludeEmployerNameInReport = "1";
    public static excludeEmployerNameInReport = "2";
    public static LoggenInUserLabelForReport = "Diary entries for";

    //For set target section in report
    public static successMessageForUpdatingSetTarget = "Targets have been set.";

    //SubRoleIds
    public static SalariedGPSubRoleId = 1;
    public static Academic_SubRole_Id = 4;

    //Error message for Salariied role and Academic work category
    public static AcademicWorkBlockedError = "This is an old category. Please re-add any Academic workplace in order to record academic work.";
}

export const categoryMaxLength = 20;
export const activityMaxLength = 30;

export const namePattern = /^[A-Za-z0-9-_ ]+$/;

//Dairy  Default Employer Name Pattern
export const EmployerNamePattern = /^Workplace [0-9].*$/;

//Dairy  Default Employer Name Pattern for report
export const EmployerNamePatternForReport = /^Workplace [0-9].*$/;

export const errorMessages = {
    pattern: 'Only letters, numbers, underscore and hyphen are allowed.',
    hoursPatternRange: 'Please enter the hours value between 0 to 60.',
    minutesPatternRange: 'Please enter the minutes value between 0 to 59.',
    sessionPatternRange: 'Please enter the session value between 0 to 14.'
};

export const diaryErrorMessages = {
    isDutyDayExistForLeave: 'You cannot be on leave at the same time as a duty/on-call period.',
    isLeaveExistForDutyday: 'Cannot be on duty while on annual leave.',
    isDutyDayExist: 'You cannot add a break to a duty/on-call period.',
    isDutyDayExistForDutyOnCall: 'Already duty/on-call activity exist for this date and time.',
    isLeaveExist: 'Already annual leave activity exist for this date and time.',
    isActivityExist: 'There is already an activity at this time.',
    isArchievedEmployerActivityExist: "You cannot add a new activity as there is an activity belonging to archived workplace details.",
    isOtherActivityExist: 'You have activities in the diary for this period, modify any DCC/ICC activities to show they are duty/on-call work.',
    isDCCOrICCActivityExist: 'Already DCC/ICC activity exist for this date and time.',
    isBreakExist: 'Already break activity exist for this date and time.'
};

export const getRequiredErrorMessageForCountry = (fieldName: any) => {
    return `Select a ${fieldName}.`;
};

//Path constants
export const employerListUrl = "/employerlist";
export const addEmployerUrl = "/addemployers";
export const diaryUrl = "/diary";
export const reportsUrl = "/reports";
export const feedbackUrl = "/feedback";
export const helpUrl = "/help";
export const userLandingPageUrl = "/userlandingpage";
export const workActivityUrl = "/workActivity";
export const unAuthorizedPageUrl = "/unauthorised";
export const faqUrl = "/faqs";


export const contentUrl = "/content";
export const jobCategoriesUrl = "/jobcategory";
export const createJobCategoriesUrl = "/createjobcategory";
export const updateJobCategoriesUrl = "/updatejobcategory/";
export const viewJobCategoriesUrl = "/viewjobcategory/";
export const publicHolidaysUrl = "/publicholidaylist";
export const ViewPublicHolidaysUrl = "/viewpublicholiday/";
export const countryUrl = "/country";
export const addCountryUrl = "/addcountry";
export const editCountryUrl = "/editcountry/";
export const viewCountryUrl = "/viewcountry/";
export const workhourUrl = "/workhour";
export const addWorkhourUrl = "/addWorkHour";
export const workhourDetailsUrl = "/workhourDetails/";
export const addWorkhourDetailsUrl = "/addWorkhourDetails/";
export const updateWorkhourDetailsUrl = "/updateWorkhourDetails/";
export const viewWorkhourDetailsUrl = "/viewWorkhourDetails/";
export const jobSubcategoryUrl = "/jobsubcategory/";
export const addJobSubcategoryUrl = "/addjobsubcategory/";
export const editJobSubcategoryUrl = "/editjobsubcategory/";
export const viewJobSubcategoryUrl = "/viewjobsubcategory/";
export const rateLimitingUrl = "/ratelimiting";


//For set target section in report
export const setTargetErrorMessages = {
    lowHoursAndMinutes: 'You need to set a target of more than 10 minutes each week.',
    highHoursAndMinutes: 'You need to set a target which is less than 48 hours each week.',
};